import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import NewFormTextInput from "../../../../../../components/FormTextInput/NewFormTextInput";
import CountryCodePhoneInput from "../../../../../../components/CountryCodePhoneInput/CountryCodePhoneInput";
import { isValidPhoneNumber } from "libphonenumber-js";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import FieldFileDropZone from "../../../../../../components/FileDropZone/FieldFileDropZone";
import styles from "./PublicWebform.module.css";
import dayjs from "dayjs";
import SaveBtn from "../../../../../../components/Buttons/SaveBtn";
import nurtureLogo from "../components/Assets/nurtureLogo.svg";

function FormFields(props: any) {
  const {
    fields,
    setFields,
    CreateContact,
    publicWebform,
    contactCreateLoading,
  } = props;

  const hasRequiredFieldsEmpty = fields?.some(
    (field: any) => field.required && field.fieldValue === ""
  );

  const hasFieldValidFalse = fields?.some((field: any) => !field.isValid);

  const handleChange = (fieldId: string, value: any, isValid: boolean) => {
    const updatedFields = fields.map((field: any) => {
      if (field.id === fieldId) {
        return { ...field, fieldValue: value, isValid };
      }

      const findField = fields.find((f: any) => f.id === fieldId);
      if (
        findField?.fieldType === "COURSE" ||
        findField?.fieldType === "BRANCH"
      ) {
        if (field.fieldType === "BATCH") {
          return { ...field, fieldValue: "" };
        }
      }

      return field;
    });

    setFields(updatedFields);
  };

  const handlePhoneChange = (
    fieldId: string,
    value: any,
    code: any,
    isValid: boolean
  ) => {
    const updatedFields = fields.map((field: any) =>
      field.id === fieldId
        ? {
            ...field,
            fieldValue: value,
            isValid: isValid,
            countryCode: code,
          }
        : field
    );
    setFields(updatedFields);
  };

  const findFieldByType = (type: string) => {
    return fields?.find((field: any) => field.fieldType === type);
  };

  const findFieldByFieldname = (name: string) => {
    return fields?.find((field: any) => field.fieldName === name);
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    try {
      if (!hasRequiredFieldsEmpty) {
        let leadDefaultFiels: any[] = [];
        const courseField = findFieldByType("COURSE");
        const branchField = findFieldByType("BRANCH");
        const batchField = findFieldByType("BATCH");

        if (courseField && courseField.fieldValue !== "") {
          leadDefaultFiels.push({
            course: courseField.fieldValue,
            domainName: courseField.fieldType,
            fieldType: courseField.fieldType,
          });
        }
        if (branchField && branchField.fieldValue !== "") {
          leadDefaultFiels.push({
            branch: branchField.fieldValue,
            domainName: branchField.fieldType,
            fieldType: branchField.fieldType,
          });
        }

        if (batchField && batchField.fieldValue !== "") {
          leadDefaultFiels.push({
            batch: batchField.fieldValue,
            domainName: batchField.fieldType,
            fieldType: batchField.fieldType,
          });
        }

        const customFields = fields
          ?.filter(
            (field: any) => field.type === "CUSTOM" && field.fieldValue !== ""
          )
          .map((field: any) => ({
            [field.fieldName]: field.fieldValue,
            fieldType: field?.fieldType,
            type: field?.type,
            fieldValue: field?.fieldValue,
            fieldName: field?.fieldName,
            options: field?.options,
            ...(field?.fieldType === "phone" && {
              countryCode: field?.countryCode,
            }),
            // id: field?.id,
          }));

        const name = findFieldByFieldname("name")?.fieldValue.split(" ") || "";
        const phone = findFieldByFieldname("phone") || "";

        const body = {
          webformId: publicWebform?.id,
          webformName: publicWebform?.formName,
          instituteId: publicWebform.instituteId,
          instituteName: publicWebform?.instituteName || "",
          firstName: name.shift() || "",
          lastName: name.join(" ") || "",
          email: findFieldByFieldname("email")?.fieldValue || "",
          contactNumber: phone?.fieldValue?.slice(phone?.countryCode?.length),
          countryCode: phone?.countryCode,
          assignedToName: publicWebform?.assignedToName,
          assignedToId: publicWebform?.assignedToId,
          enquiryPriority: "NORMAL",
          enquirySource: "WEBFORM",

          courseId: findFieldByType("COURSE")
            ? findFieldByType("COURSE")?.fieldValue
            : "",
          branchId:
            publicWebform?.type === "BRANCH_SPECIFIC"
              ? publicWebform?.branchId
              : findFieldByType("BRANCH")?.fieldValue,
          batchId: findFieldByType("BATCH")
            ? findFieldByType("BATCH")?.fieldValue
            : "",

          otherDetails: [...leadDefaultFiels, ...customFields],

          status: publicWebform?.isCollectPayment ? "LOST" : "ACTIVE",
          courseName: "",
          branchName: "",
          isCreateLead:
            publicWebform?.webformType === "LEAD_CREATION" ? true : false,
          isCollectPayment: publicWebform?.isCollectPayment,
          amount: publicWebform?.amount,
          // demoTiming: "",
          // campaignId: "",
        };

        CreateContact({
          ...body,
          createdById: publicWebform.createdById,
          createdByName: publicWebform.createdByName,
        });
      }
    } catch (error) {}
  };

  const renderField = (field: any) => {
    switch (field.fieldType) {
      case "text":
        return (
          <div className={styles.additionalFieldWrap}>
            <NewFormTextInput
              onChange={(e: any) =>
                handleChange(
                  field.id,
                  e.target.value,
                  field.required && e.target.value.trim() === "" ? false : true
                )
              }
              label={
                field.fieldName
                  ? field.fieldName.charAt(0).toUpperCase() +
                    field.fieldName.slice(1).toLowerCase()
                  : ""
              }
              require={field.required}
              value={field.fieldValue || ""}
              variant="standard"
              fullWidth
              error={field.required && !field.isValid}
            />
          </div>
        );

      case "email":
        return (
          <div className={styles.additionalFieldWrap}>
            <NewFormTextInput
              onChange={(e: any) => {
                const isValidEmail =
                  /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,4})+$/.test(
                    e.target.value
                  );
                handleChange(
                  field.id,
                  e.target.value,
                  (field.required && e.target.value.trim() === "") ||
                    (e.target.value.trim() !== "" && !isValidEmail)
                    ? false
                    : true
                );
              }}
              label={
                field.fieldName
                  ? field.fieldName.charAt(0).toUpperCase() +
                    field.fieldName.slice(1).toLowerCase()
                  : ""
              }
              require={field.required}
              value={field.fieldValue || ""}
              variant="standard"
              fullWidth
              error={!field.isValid}
              type="email"
              validate={true}
            />
          </div>
        );

      case "phone":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.additionalFieldLabel}>
              {field.fieldName}{" "}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <CountryCodePhoneInput
              key={field.id}
              value={field.fieldValue || ""}
              onChange={(event: any, country: any) => {
                const isValid = isValidPhoneNumber(
                  `+${country.dialCode}${event.replace(country.dialCode, "")}`,
                  country.countryCode.toUpperCase()
                );

                handlePhoneChange(
                  field.id,
                  event,
                  country.dialCode,
                  (field.required &&
                    event.slice(country.countryCode?.length || 0).trim()
                      .length === 0) ||
                    (!isValid && event !== country.dialCode)
                    ? false
                    : true
                );
              }}
              error={
                field.fieldValue?.slice(field.countryCode?.length || 0).trim()
                  .length > 0
                  ? field.isValid
                  : true
              }
            />

            {!field.isValid &&
              field.required &&
              !field.fieldValue?.slice(field.countryCode?.length || 0) && (
                <FormHelperText error>Please fill the field</FormHelperText>
              )}
          </div>
        );

      case "radio":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.additionalFieldLabel}>
              {field.fieldName}{" "}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <FormControl component="fieldset" key={field.id}>
              <RadioGroup
                row
                value={field.fieldValue || ""}
                onChange={(e) =>
                  handleChange(
                    field.id,
                    e.target.value,
                    field.required && e.target.value.trim() === ""
                      ? false
                      : true
                  )
                }
              >
                {field?.options?.map((option: any) => (
                  <FormControlLabel
                    key={option.id}
                    value={option.id}
                    control={
                      <Radio
                        sx={{
                          strokeWidth: 1,
                          color: "#D0D5DD",
                        }}
                      />
                    }
                    label={
                      <div
                        style={{
                          fontSize: "13PX",
                          textTransform: "capitalize",
                        }}
                      >
                        {option?.name}
                      </div>
                    }
                  />
                ))}
              </RadioGroup>
            </FormControl>
            {!field.isValid && field.required && (
              <FormHelperText error>Please fill the field</FormHelperText>
            )}
          </div>
        );

      case "date":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.additionalFieldLabel}>
              {field.fieldName}{" "}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <LocalizationProvider dateAdapter={AdapterDayjs} key={field.id}>
              <DesktopDatePicker
                sx={{
                  zIndex: "999999 !important",
                  width: "100%",
                  fontSize: "14px",
                  "& .MuiOutlinedInput-input": {
                    fontSize: "14px",
                    color: "#142C44",
                    padding: "9px",
                  },
                }}
                format="DD/MM/YYYY"
                onChange={(date: any) => {
                  const timestamp = date ? dayjs(date).valueOf() : null;
                  handleChange(
                    field.id,
                    timestamp,
                    field.required && timestamp === 0 ? false : true
                  );
                }}
                value={field.fieldValue ? dayjs(field.fieldValue) : null}
              />
            </LocalizationProvider>
            {!field.isValid && field.required && (
              <FormHelperText error>Please fill the field</FormHelperText>
            )}
          </div>
        );

      case "checkbox":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.additionalFieldLabel}>
              {field.fieldName}{" "}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <FormControl component="fieldset" key={field.id}>
              {field?.options?.map((option: any) => (
                <FormControlLabel
                  key={option.id}
                  control={
                    <Checkbox
                      checked={field.fieldValue?.includes(option.id) || false}
                      onChange={(e) => {
                        const newValue = e.target.checked
                          ? [...(field.fieldValue || []), option.id]
                          : field.fieldValue.filter(
                              (id: any) => id !== option.id
                            );
                        handleChange(
                          field.id,
                          newValue,
                          field.required && newValue?.length === 0
                            ? false
                            : true
                        );
                      }}
                      sx={{
                        strokeWidth: 1,
                        color: "#D0D5DD",
                      }}
                    />
                  }
                  label={
                    <div
                      style={{
                        fontSize: "13PX",
                        textTransform: "capitalize",
                      }}
                    >
                      {option?.name}
                    </div>
                  }
                />
              ))}
            </FormControl>
            {!field.isValid && field.required && (
              <FormHelperText error>Please fill the field</FormHelperText>
            )}
          </div>
        );

      case "select":
        return (
          <div className={styles.additionalFieldWrap}>
            <FormControl key={field.id} fullWidth size="small">
              <div className={styles.additionalFieldLabel}>
                {field.fieldName}
                {field.required === true && (
                  <span style={{ color: "red", margin: "0 4PX" }}>*</span>
                )}
              </div>
              <Select
                value={field.fieldValue || ""}
                onChange={(e) =>
                  handleChange(
                    field.id,
                    e.target.value,
                    field.required && e.target.value.trim() === ""
                      ? false
                      : true
                  )
                }
                sx={{
                  borderRadius: "5px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "5px",
                  },
                }}
                error={!field.isValid}
                MenuProps={{
                  PaperProps: {
                    style: {
                      boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
                      border: "1px solid #D4D4D8",
                      borderRadius: "6PX",
                      maxHeight: "250px",
                      overflowY: "scroll",
                    },
                  },
                }}
              >
                {field?.options?.map((option: any) => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    sx={{
                      color: "#667085",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {!field.isValid && field.required && (
              <FormHelperText error>Please fill the field</FormHelperText>
            )}
          </div>
        );

      case "COURSE":
        return (
          <div className={styles.additionalFieldWrap}>
            <FormControl key={field.id} fullWidth size="small">
              <div className={styles.additionalFieldLabel}>
                {field.fieldName}
                {field.required === true && (
                  <span style={{ color: "red", margin: "0 4PX" }}>*</span>
                )}
              </div>
              <Select
                value={field.fieldValue || ""}
                onChange={(e) =>
                  handleChange(
                    field.id,
                    e.target.value,
                    field.required && e.target.value.trim() === ""
                      ? false
                      : true
                  )
                }
                sx={{
                  borderRadius: "5px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "5px",
                  },
                }}
                error={!field.isValid}
                MenuProps={{
                  PaperProps: {
                    style: {
                      boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
                      border: "1px solid #D4D4D8",
                      borderRadius: "6PX",
                      maxHeight: "250px",
                      overflowY: "scroll",
                    },
                  },
                }}
              >
                {field?.options?.length > 0
                  ? field?.options?.map((option: any) => (
                      <MenuItem
                        key={option.id}
                        value={option.id}
                        sx={{
                          color: "#667085",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        {option.name}
                      </MenuItem>
                    ))
                  : [
                      <MenuItem
                        key="no-branches"
                        disabled
                        sx={{
                          color: "#667085",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        No courses found
                      </MenuItem>,
                    ]}
              </Select>
            </FormControl>
            {!field.isValid && field.required && (
              <FormHelperText error>Please fill the field</FormHelperText>
            )}
          </div>
        );

      case "BRANCH":
        return (
          <div className={styles.additionalFieldWrap}>
            <FormControl key={field.id} fullWidth size="small">
              <div className={styles.additionalFieldLabel}>
                {field.fieldName}
                {field.required === true && (
                  <span style={{ color: "red", margin: "0 4PX" }}>*</span>
                )}
              </div>
              <Select
                value={field.fieldValue || ""}
                onChange={(e) =>
                  handleChange(
                    field.id,
                    e.target.value,
                    field.required && e.target.value.trim() === ""
                      ? false
                      : true
                  )
                }
                sx={{
                  borderRadius: "5px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "5px",
                  },
                }}
                error={!field.isValid}
                MenuProps={{
                  PaperProps: {
                    style: {
                      boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
                      border: "1px solid #D4D4D8",
                      borderRadius: "6PX",
                      maxHeight: "250px",
                      overflowY: "scroll",
                    },
                  },
                }}
              >
                {field?.options?.length > 0
                  ? field?.options?.map((option: any) => (
                      <MenuItem
                        key={option.id}
                        value={option.id}
                        sx={{
                          color: "#667085",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        {option.name}
                      </MenuItem>
                    ))
                  : [
                      <MenuItem
                        key="no-branches"
                        disabled
                        sx={{
                          color: "#667085",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        No branches found
                      </MenuItem>,
                    ]}
              </Select>
            </FormControl>
            {!field.isValid && field.required && (
              <FormHelperText error>Please fill the field</FormHelperText>
            )}
          </div>
        );

      case "BATCH":
        const courseField = findFieldByType("COURSE");
        const branchField = findFieldByType("BRANCH");
        const filteredOptions = field?.options?.filter((option: any) => {
          const matchesCourse =
            courseField && courseField?.fieldValue
              ? option.courseId === courseField.fieldValue
              : true;
          const matchesBranch =
            publicWebform?.type === "BRANCH_SPECIFIC"
              ? option.branchId === publicWebform?.branchId
              : branchField && branchField?.fieldValue
              ? option.branchId === branchField.fieldValue
              : true;
          return matchesCourse && matchesBranch;
        });
        return (
          <div className={styles.additionalFieldWrap}>
            <FormControl key={field.id} fullWidth size="small">
              <div className={styles.additionalFieldLabel}>
                {field.fieldName}
                {field.required === true && (
                  <span style={{ color: "red", margin: "0 4PX" }}>*</span>
                )}
              </div>
              <Select
                value={field.fieldValue || ""}
                onChange={(e) =>
                  handleChange(
                    field.id,
                    e.target.value,
                    field.required && e.target.value.trim() === ""
                      ? false
                      : true
                  )
                }
                sx={{
                  borderRadius: "5px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "5px",
                  },
                }}
                error={!field.isValid}
                MenuProps={{
                  PaperProps: {
                    style: {
                      boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
                      border: "1px solid #D4D4D8",
                      borderRadius: "6PX",
                      maxHeight: "250px",
                      overflowY: "scroll",
                    },
                  },
                }}
              >
                {filteredOptions?.length > 0
                  ? filteredOptions?.map((option: any) => (
                      <MenuItem
                        key={option.id}
                        value={option.id}
                        sx={{
                          color: "#667085",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        {option.name}
                      </MenuItem>
                    ))
                  : [
                      <MenuItem
                        key="no-batches"
                        disabled
                        sx={{
                          color: "#667085",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        No batches found
                      </MenuItem>,
                    ]}
              </Select>
            </FormControl>
            {!field.isValid && field.required && (
              <FormHelperText error>Please fill the field</FormHelperText>
            )}
          </div>
        );

      case "file":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.additionalFieldLabel}>
              {field.fieldName}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <FieldFileDropZone field={field} onFieldChange={handleChange} />
            {!field.isValid && field.required && (
              <FormHelperText error>Please fill the field</FormHelperText>
            )}
          </div>
        );

      case "profilePic":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.additionalFieldLabel}>
              {field.fieldName}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <FieldFileDropZone
              field={field}
              onFieldChange={handleChange}
              crop={true}
              webform={true}
              instituteId={publicWebform.instituteId}
            />
            {!field.isValid && field.required && (
              <FormHelperText error>Please fill the field</FormHelperText>
            )}
          </div>
        );
      case "image":
        return (
          <div className={styles.additionalFieldWrap}>
            <div className={styles.additionalFieldLabel}>
              {field.fieldName}
              {field.required === true && (
                <span style={{ color: "red", margin: "0 4PX" }}>*</span>
              )}
            </div>
            <FieldFileDropZone
              field={field}
              onFieldChange={handleChange}
              crop={false}
              webform={true}
              instituteId={publicWebform.instituteId}
              // maxSize={30 * 1024}
            />
            {!field.isValid && field.required && (
              <FormHelperText error>Please fill the field</FormHelperText>
            )}
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div>
      <div
        style={{
          maxWidth: "100%",
          // width: "500px",
          margin: "0 auto",
          overflowY: "auto",
          maxHeight: "100VH",
          padding: "50px 10PX 30px 10px",
        }}
        className={styles.formFieldsWrap}
      >
        <div className={styles.webformName}>
          {publicWebform?.formName
            ?.split(" ")
            .map((word: any, index: number) =>
              index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
            )
            .join(" ")}
        </div>
        <div>{fields?.map((field: any) => renderField(field))}</div>
        <div className={styles.webformBtnWrap}>
          <SaveBtn
            disabled={
              hasRequiredFieldsEmpty ||
              hasFieldValidFalse ||
              contactCreateLoading
            }
            onClick={handleSubmit}
            buttonText={publicWebform?.buttonName}
            loader={contactCreateLoading}
          />
        </div>
        <div className={styles.webformBottom}>
          {publicWebform?.logo ? (
            <>
              <img
                src={publicWebform?.logo}
                alt="institutionLogo"
                width="100px"
                height="100px"
              />

              <div style={{ fontSize: "12px" }}>
                {publicWebform?.instituteName}
              </div>
            </>
          ) : (
            <>
              <img src={nurtureLogo} alt="nurtureLogo" />
            </>
          )}
          {/* <div style={{ color: "#7C7C7C", lineHeight: 1, fontSize: "12px" }}>
            Powered by
          </div>
          <div style={{ fontSize: "12px" }}>nurturecrm.in</div> */}
        </div>
      </div>
    </div>
  );
}

export default FormFields;
